__turbopack_context__.v({
  "documentChecklistBlockPadding": "DocumentChecklistBlock-module__kfYvoa__documentChecklistBlockPadding",
  "documentChecklistBlock__item": "DocumentChecklistBlock-module__kfYvoa__documentChecklistBlock__item",
});
